module.exports = __webpack_public_path__ + "img/i-info-security-1.6f1c256c.png";